import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import OurStoryAndImpact from "./sections/OurStoryAndImpact";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <OurStoryAndImpact />
      <Footer />
    </div>;
}